import React from 'react'
import PropTypes from 'prop-types';

export const SkuLabelTitle = ({title}:any) => {
    return (
        <h5 className="text-muted text-center">{title}</h5>
    )
}
SkuLabelTitle.propTypes = {
    title:PropTypes.string.isRequired
}
